<div
  aria-live="polite"
  role="alert"
  [attr.aria-label]="title() || message() || 'Information message'"
  class="ngkit-inline-message"
  [class]="variantClass()"
>
  <i class="pi ngkit-inline-message-icon"></i>
  @if (title()) {
    <span class="ngkit-inline-message__title">{{ title() }}</span>
  }
  @if (message()) {
    <div
      #messageTpl
      class="ngkit-inline-message__description"
      [pTooltip]="tooltipMessage()"
      tooltipPosition="top"
      (ngkitResizeObserver)="setMessageTooltip(messageTpl)"
    >
      {{ message() }}
    </div>
  }
  <div
    class="ngkit-inline-message__buttons"
    [class]="{
      'ngkit-flex-none': bannerMode(),
      'ngkit-flex-justify-content-end': alignButtonRight(),
    }"
  >
    @for (action of actions().slice(0, bannerMode() ? 3 : 1); track action) {
      @if (action.type === "button") {
        <p-button
          [dt]="inlineMessageButtonDt"
          [class]="'ngkit-button ngkit-button-sm'"
          [variant]="action.variant"
          [severity]="action.severity ? action.severity : 'primary'"
          [label]="action.title"
          (click)="action.callback && action.callback()"
        />
      }
      @if (action.type === "link") {
        <a class="ngkit-inline-link" [href]="action.href" [target]="action.target || '_self'">{{ action.title }}</a>
      }
    }
  </div>
</div>
